"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Rendall API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SensorToJSON = exports.SensorFromJSONTyped = exports.SensorFromJSON = exports.instanceOfSensor = void 0;
var runtime_1 = require("../runtime");
var SensorSite_1 = require("./SensorSite");
var SensorStatus_1 = require("./SensorStatus");
var ShippingInfo_1 = require("./ShippingInfo");
/**
 * Check if a given object implements the Sensor interface.
 */
function instanceOfSensor(value) {
    var isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "uuid" in value;
    isInstance = isInstance && "deploymentID" in value;
    isInstance = isInstance && "ipAddress" in value;
    isInstance = isInstance && "subnetMask" in value;
    isInstance = isInstance && "defaultGateway" in value;
    isInstance = isInstance && "primaryDns" in value;
    isInstance = isInstance && "secondaryDns" in value;
    isInstance = isInstance && "model" in value;
    isInstance = isInstance && "deviceType" in value;
    isInstance = isInstance && "serialNumber" in value;
    isInstance = isInstance && "_configuration" in value;
    isInstance = isInstance && "status" in value;
    return isInstance;
}
exports.instanceOfSensor = instanceOfSensor;
function SensorFromJSON(json) {
    return SensorFromJSONTyped(json, false);
}
exports.SensorFromJSON = SensorFromJSON;
function SensorFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'name': json['name'],
        'uuid': json['uuid'],
        'deploymentID': json['deploymentID'],
        'ipAddress': json['ipAddress'],
        'subnetMask': json['subnetMask'],
        'defaultGateway': json['defaultGateway'],
        'primaryDns': json['primaryDns'],
        'secondaryDns': json['secondaryDns'],
        'model': json['model'],
        'deviceType': json['device_type'],
        'serialNumber': json['serialNumber'],
        '_configuration': json['configuration'],
        'site': !(0, runtime_1.exists)(json, 'site') ? undefined : (0, SensorSite_1.SensorSiteFromJSON)(json['site']),
        'macAddress': !(0, runtime_1.exists)(json, 'macAddress') ? undefined : json['macAddress'],
        'status': (0, SensorStatus_1.SensorStatusFromJSON)(json['status']),
        'shippingInfo': !(0, runtime_1.exists)(json, 'shipping_info') ? undefined : (0, ShippingInfo_1.ShippingInfoFromJSON)(json['shipping_info']),
        'technicalRequirements': !(0, runtime_1.exists)(json, 'technical_requirements') ? undefined : json['technical_requirements'],
        'notes': !(0, runtime_1.exists)(json, 'notes') ? undefined : json['notes'],
    };
}
exports.SensorFromJSONTyped = SensorFromJSONTyped;
function SensorToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'name': value.name,
        'uuid': value.uuid,
        'deploymentID': value.deploymentID,
        'ipAddress': value.ipAddress,
        'subnetMask': value.subnetMask,
        'defaultGateway': value.defaultGateway,
        'primaryDns': value.primaryDns,
        'secondaryDns': value.secondaryDns,
        'model': value.model,
        'device_type': value.deviceType,
        'serialNumber': value.serialNumber,
        'configuration': value._configuration,
        'site': (0, SensorSite_1.SensorSiteToJSON)(value.site),
        'macAddress': value.macAddress,
        'status': (0, SensorStatus_1.SensorStatusToJSON)(value.status),
        'shipping_info': (0, ShippingInfo_1.ShippingInfoToJSON)(value.shippingInfo),
        'technical_requirements': value.technicalRequirements,
        'notes': value.notes,
    };
}
exports.SensorToJSON = SensorToJSON;
